import { render, staticRenderFns } from "./bigDataV2.vue?vue&type=template&id=30ba0e5a&scoped=true&"
import script from "./bigDataV2.vue?vue&type=script&lang=js&"
export * from "./bigDataV2.vue?vue&type=script&lang=js&"
import style0 from "./bigDataV2.vue?vue&type=style&index=0&id=30ba0e5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ba0e5a",
  null
  
)

export default component.exports